<template>
  <div
    class="bg-surface-default-mid grid grid-cols-1 grid-rows-[min-content] pb-72"
  >
    <Navigation class="z-[9]" />

    <NuxtPage />
  </div>
</template>

<script lang="ts" setup>
import Navigation from './components/Navigation/Navigation.vue'
</script>
